<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/M4cKMV/media/FC-9781398489479.jpg?1685790453985" alt="This image is the cover for the book Covid-19 Life"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Covid-19 Life
      </h1>
      <p class="bookDescription body article font2">
        <p>The impact Covid-19 has had on the world was something that no one in our lifetime will forget. While living through this, I have documented my experience in this area to help this era and the next to look back and see if my experience is something the human race can benefit from. I want to share my own life with the reader, detailing what I had done daily – to show the positive and negative impacts the Covid-19 crisis had on me. This was something everyone had to go through together – united. Everyone has a different story to tell and this one is mine. If you move forward and read my story, there will be a great deal of heartbreak in my journey. Perhaps you can relate? But one thing is for sure, Covid-19 has taken a great deal of time and that reminds us to enjoy the time we have left.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        George Knowlson
      </h2>
      
      <p class="authorDescription body article">G.T.K.B is a young man who felt like an outcast his entire life and wanted to keep his gifts a secret. But that from his position has been a good thing. G.T.K.B from not blindly following inner circle when he was younger, he has been able to see people for who they really are and says it, as it is. That is the cost for being a misunderstood character in a broken world.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?76d48b85